module.exports = "<!-- Generated by IcoMoon.io -->\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n<title>merge</title>\n<path d=\"M7.5 8.016l4.5-4.5 4.5 4.5h-3.516v6.375l-6 6-1.406-1.406 5.438-5.391v-5.578h-3.516zM17.016 20.391l-3.422-3.375 1.406-1.406 3.422 3.375z\"></path>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./app/assets/svg/merge.svg
// module id = 742
// module chunks = 0